<template>
  <LayerHeatmap v-if="currentSensordataType === 'wifi'" :before="before" />
  <LayerSensorData
    v-if="source && currentSensordataType && currentSensordataType !== 'wifi'"
    :before="before"
    :layerId="layerIdSensorData"
    :source="source"
    :currentSensordataType="currentSensordataType"
  />
</template>

<script lang="ts" setup>
import { computed, onBeforeUnmount, toRefs } from 'vue'
import { useStore } from 'vuex'
import LayerHeatmap from './heatmaps/LayerHeatmap.vue'
import LayerSensorData from './LayerSensorData.vue'
import { collectSensorData, getPresence } from '@/utils/format-sensor-values'
import { SENSOR_DATA_ROOM } from '@/interfaces/sensordata.interface'

interface PROPS {
  before: string
  layerIdSensorData: string
}
const store = useStore()

const props = defineProps<PROPS>()
const { before, layerIdSensorData } = toRefs(props)
const sourceIdSensorData = 'source-room-sensor-data'

const roomsForSelectedLevel = computed(() => store.state.roomsForSelectedLevel)
const currentSensordataType = computed<string | null>(
  () => store.state.planview.currentSensordataType
)
const sensorDataForSelectedLevel = computed<SENSOR_DATA_ROOM[]>(
  () => store.state.planview.sensorDataForSelectedLevel
)

const source = computed(() => {
  if (!roomsForSelectedLevel.value || !sensorDataForSelectedLevel.value.length) return null

  const roomsWithGeometry = roomsForSelectedLevel.value.data.features.filter(
    (room) => room.geometry
  )
  roomsWithGeometry.forEach((room) => {
    const roomData = sensorDataForSelectedLevel.value.find(
      (roomSensorValues) => roomSensorValues.objectId === room.properties.id
    )
    if (!roomData) return
    room.properties.temperature = collectSensorData(roomData, 'Temperature')
    room.properties.co2 = collectSensorData(roomData, 'CO2')
    room.properties.presence = getPresence(roomData)
    room.properties.humidity = collectSensorData(roomData, 'Humidity')
    room.properties.flow = collectSensorData(roomData, 'Flow')
  })

  return {
    type: 'geojson',
    data: {
      id: sourceIdSensorData,
      type: 'FeatureCollection',
      features: roomsWithGeometry
    }
  }
})

onBeforeUnmount(() => {
  store.commit('planview/SET_IS_SENSORDATA_SHOWING', { value: false })
})
</script>
